import { UseFormReturn } from 'react-hook-form';
import { MiscellaneousField } from '../../reportsTypes';
import {
  FormControl,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
  InfoIconTooltip,
  TimeDurationPicker,
} from '@ais-ui/ui-core';

interface TimeDurationItemProps {
  fieldName: string;
  form: UseFormReturn;
  fieldInfo: MiscellaneousField;
}

export const MiscellaneousTimeDurationItem = ({
  fieldName,
  form,
  fieldInfo,
}: TimeDurationItemProps) => {
  return (
    <FormField
      key={fieldName}
      control={form.control}
      name={fieldName}
      render={({ field }) => (
        <FormItem>
          <div className="flex justify-between">
            <FormLabel>
              {fieldInfo.name}: {fieldInfo.required && '*'}
            </FormLabel>
            {fieldInfo.help && (
              <InfoIconTooltip className="mr-2">
                {fieldInfo.help}
              </InfoIconTooltip>
            )}
          </div>
          <FormControl onChange={() => form.clearErrors()}>
            <TimeDurationPicker
              value={field.value}
              onChange={field.onChange}
              format="HH:MM:SS"
            ></TimeDurationPicker>
          </FormControl>
          <FormMessage />
        </FormItem>
      )}
    />
  );
};
